<template>
  <div class="version-list">
    <loading :isShow="loading" />
    <Card class="version-item" v-for="(bean,i) in list" :key="i" @click.native="openDetail(bean)">
      <!-- <div class="name">版本号：<span class="blue">{{bean.versionNo}}</span></div> -->
      <Tag color="primary">{{bean.versionNo|cutString(7)}}</Tag>
      <div class="time">
        <div class="label">生效时间</div>
        <div class="text">{{bean.versionTime}}</div>
      </div>
    </Card>
    <noData v-if="list.length==0 && !loading" class="null-box"></noData>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import noData from '@/components/commons/noData';
export default {
  mixins: [common],
  components: { noData },
  props: {
    query:{
      default(){
        return {};
      }
    },
    orgId:null,
  },
  data() {
    return {
      loading: false,
      list:[],
    };
  },
  mounted(){
  },
  methods: {
    getData(){
      this.loading = true;
      this.$http({
        url: '/buz/commission/productRateDetailSnapShotList',
        type: 'GET',
        data: {
          productCode: this.query.productCode,
          organizationId: this.query.id,
        }
      }).then(res=>{
        this.list = res.data;
      }).finally(()=>{
        this.loading = false;
      })
    },
    openDetail(item){
      this.openPageTabTags(
        '/productResource/fee/rateHistoryDetail', 
        {
          ...this.query,
          snapShotId:item.snapShotId
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.version-list {
  display: flex;
  flex-wrap: wrap;
  .version-item {
    width: 350px;
    cursor: pointer;
    margin-right: 15px;
    margin-bottom: 15px;
    position: relative;
    .blue {
      color: #236dff;
      text-decoration: underline;
    }
    .ivu-tag {
      position: absolute;
      right: 10px;
      top: 10px;
      margin-right: 0;
    }
    .label {
      color: #666;
      margin-bottom: 5px;
    }
    .text {
      color: #000;
    }
  }
  
  .null-box {
    margin: auto;
  }
}
</style>
